import React, { useState, useEffect } from "react";
import { db, storage } from "../../firebaseConfig";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import toast from "react-hot-toast";

function Etkinlikler() {
  const [etkinlikler, setEtkinlikler] = useState([]);
  const [popupEtkinlik, setPopupEtkinlik] = useState(null);
  const [addPopupVisible, setAddPopupVisible] = useState(false);
  const [newEtkinlik, setNewEtkinlik] = useState({
    baslik: "",
    icerik: "",
    img: "",
    aktifPasif: true,
    startDate: "",
    endDate: "",
    konum: "",
    adres: "",
  });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  // Firestore'dan etkinlikleri çekme
  useEffect(() => {
    const fetchEtkinlikler = async () => {
      const querySnapshot = await getDocs(collection(db, "buyuksehir_etkinlikler"));
      const etkinlikListesi = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setEtkinlikler(etkinlikListesi);
    };
    fetchEtkinlikler();
  }, []);

  // Görsel seçme ve önizleme
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        toast.error("Lütfen bir görsel dosyası seçin.");
        return;
      }
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  // Görsel yükleme işlemi
  const uploadImage = async (file) => {
    if (!file) return null;
    const storageRef = ref(storage, `etkinlikler/${file.name}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  };

  // Yeni etkinlik ekleme
  const handleAddEtkinlik = async () => {
    try {
      const imgUrl = await uploadImage(file); // Görseli yükle ve URL'yi al
      const docRef = await addDoc(collection(db, "buyuksehir_etkinlikler"), {
        ...newEtkinlik,
        img: imgUrl || "",
        startDate: newEtkinlik.startDate,
        endDate: newEtkinlik.endDate,
      });

      await updateDoc(doc(db, "buyuksehir_etkinlikler", docRef.id), {
        id: docRef.id,
      });

      setEtkinlikler((prev) => [
        ...prev,
        { id: docRef.id, ...newEtkinlik, img: imgUrl },
      ]);
      toast.success("Etkinlik başarıyla eklendi!");
      setAddPopupVisible(false);
      setNewEtkinlik({
        baslik: "",
        icerik: "",
        img: "",
        aktifPasif: true,
        startDate: "",
        endDate: "",
        konum: "",
        adres: "",
      });
      setFile(null);
      setPreview(null);
    } catch (error) {
      console.error("Etkinlik eklenirken hata oluştu:", error);
      toast.error("Etkinlik eklenirken bir hata oluştu!");
    }
  };

  // Etkinlik güncelleme
  const handleUpdate = async (id, updatedEtkinlik) => {
    try {
      let updatedImageUrl = popupEtkinlik.img;

      if (file) {
        updatedImageUrl = await uploadImage(file); // Yeni görsel yükleme
      }

      const etkinlikRef = doc(db, "buyuksehir_etkinlikler", id);
      await updateDoc(etkinlikRef, {
        ...updatedEtkinlik,
        img: updatedImageUrl,
      });

      setEtkinlikler((prev) =>
        prev.map((etkinlik) =>
          etkinlik.id === id
            ? { id, ...updatedEtkinlik, img: updatedImageUrl }
            : etkinlik
        )
      );
      toast.success("Etkinlik başarıyla güncellendi!");
      setPopupEtkinlik(null);
      setFile(null);
      setPreview(null);
    } catch (error) {
      console.error("Etkinlik güncellenirken hata oluştu:", error);
      toast.error("Etkinlik güncellenirken bir hata oluştu!");
    }
  };

  // Etkinlik silme
  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "buyuksehir_etkinlikler", id));
      setEtkinlikler((prev) => prev.filter((etkinlik) => etkinlik.id !== id));
      toast.success("Etkinlik başarıyla silindi!");
      setConfirmDelete(null);
    } catch (error) {
      console.error("Etkinlik silinirken hata oluştu:", error);
      toast.error("Etkinlik silinirken bir hata oluştu!");
    }
  };

  return (
    <div className="min-h-screen bg-sky-100 p-8 rounded shadow">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-extrabold text-gray-700">Etkinlikler</h1>
        <button
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg shadow-md"
          onClick={() => setAddPopupVisible(true)}
        >
          Yeni Etkinlik Ekle
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {etkinlikler.map((etkinlik) => (
          <div
            key={etkinlik.id}
            className="bg-white shadow-lg rounded-lg overflow-hidden hover:scale-105 transition-transform duration-300"
          >
            <img
              src={etkinlik.img || "https://via.placeholder.com/150"}
              alt={etkinlik.baslik}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h2 className="font-bold text-lg text-gray-800 mb-2">{etkinlik.baslik}</h2>
              <p className="text-gray-600 text-sm">{etkinlik.icerik?.slice(0, 100)}...</p>
              <p className="text-gray-500 text-xs">
                {etkinlik.startDate} - {etkinlik.endDate}
              </p>
              <div className="flex justify-between mt-4">
                <button
                  className="bg-blue-500 text-white px-3 py-1 rounded-md"
                  onClick={() => setPopupEtkinlik(etkinlik)}
                >
                  Düzenle
                </button>
                <button
                  className="bg-red-500 text-white px-3 py-1 rounded-md"
                  onClick={() => setConfirmDelete(etkinlik.id)}
                >
                  Sil
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {popupEtkinlik && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-lg">
      <h2 className="text-2xl font-bold text-gray-700 mb-4">Etkinliği Düzenle</h2>
      <input
        type="text"
        className="w-full p-3 border rounded-lg mb-4"
        value={popupEtkinlik.baslik || ""}
        onChange={(e) =>
          setPopupEtkinlik({ ...popupEtkinlik, baslik: e.target.value })
        }
        placeholder="Başlık"
      />
      <textarea
        className="w-full p-3 border rounded-lg mb-4"
        value={popupEtkinlik.icerik || ""}
        onChange={(e) =>
          setPopupEtkinlik({ ...popupEtkinlik, icerik: e.target.value })
        }
        placeholder="İçerik"
      ></textarea>
      <input
        type="date"
        className="w-full p-3 border rounded-lg mb-4"
        value={popupEtkinlik.startDate || ""}
        onChange={(e) =>
          setPopupEtkinlik({ ...popupEtkinlik, startDate: e.target.value })
        }
        placeholder="Başlangıç Tarihi"
      />
      <input
        type="date"
        className="w-full p-3 border rounded-lg mb-4"
        value={popupEtkinlik.endDate || ""}
        onChange={(e) =>
          setPopupEtkinlik({ ...popupEtkinlik, endDate: e.target.value })
        }
        placeholder="Bitiş Tarihi"
      />
      <input
        type="text"
        className="w-full p-3 border rounded-lg mb-4"
        value={popupEtkinlik.konum || ""}
        onChange={(e) =>
          setPopupEtkinlik({ ...popupEtkinlik, konum: e.target.value })
        }
        placeholder="Konum"
      />
      <div className="mb-4">
        <img
          src={popupEtkinlik.img || "https://via.placeholder.com/150"}
          alt="Eski Görsel"
          className="w-full h-48 object-cover rounded-lg"
        />
        <label
          htmlFor="updateFileInput"
          className="w-full h-20 border-2 border-dashed flex items-center justify-center rounded-md cursor-pointer hover:bg-gray-100 mt-4"
        >
          <span className="text-gray-500">Yeni görsel yüklemek için tıklayın</span>
          <input
            id="updateFileInput"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="hidden"
          />
        </label>
        {preview && (
          <img
            src={preview}
            alt="Preview"
            className="w-full h-48 object-cover rounded-lg mt-4"
          />
        )}
      </div>
      <div className="flex justify-end">
        <button
          className="bg-green-500 text-white px-5 py-2 rounded-lg shadow mr-2"
          onClick={() => handleUpdate(popupEtkinlik.id, popupEtkinlik)}
        >
          Kaydet
        </button>
        <button
          className="bg-red-500 text-white px-5 py-2 rounded-lg shadow"
          onClick={() => setPopupEtkinlik(null)}
        >
          Kapat
        </button>
      </div>
    </div>
  </div>
)}

{addPopupVisible && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-lg">
      <h2 className="text-2xl font-bold text-gray-700 mb-4">Yeni Etkinlik Ekle</h2>
      <input
        type="text"
        className="w-full p-3 border rounded-lg mb-4"
        placeholder="Başlık"
        value={newEtkinlik.baslik}
        onChange={(e) =>
          setNewEtkinlik({ ...newEtkinlik, baslik: e.target.value })
        }
      />
      <textarea
        className="w-full p-3 border rounded-lg mb-4"
        placeholder="İçerik"
        value={newEtkinlik.icerik}
        onChange={(e) =>
          setNewEtkinlik({ ...newEtkinlik, icerik: e.target.value })
        }
      ></textarea>
      <input
        type="date"
        className="w-full p-3 border rounded-lg mb-4"
        value={newEtkinlik.startDate || ""}
        onChange={(e) =>
          setNewEtkinlik({ ...newEtkinlik, startDate: e.target.value })
        }
        placeholder="Başlangıç Tarihi"
      />
      <input
        type="date"
        className="w-full p-3 border rounded-lg mb-4"
        value={newEtkinlik.endDate || ""}
        onChange={(e) =>
          setNewEtkinlik({ ...newEtkinlik, endDate: e.target.value })
        }
        placeholder="Bitiş Tarihi"
      />
      <input
        type="text"
        className="w-full p-3 border rounded-lg mb-4"
        placeholder="Konum"
        value={newEtkinlik.konum}
        onChange={(e) =>
          setNewEtkinlik({ ...newEtkinlik, konum: e.target.value })
        }
      />
      <label
        htmlFor="fileInput"
        className="w-full h-20 border-2 border-dashed flex items-center justify-center rounded-md cursor-pointer hover:bg-gray-100"
      >
        <span className="text-gray-500">Görsel yüklemek için tıklayın</span>
        <input
          id="fileInput"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="hidden"
        />
      </label>
      {preview && (
        <img src={preview} alt="Preview" className="w-full h-48 object-cover rounded-lg mt-4" />
      )}
      <div className="flex justify-end mt-4">
        <button
          className="bg-blue-500 text-white px-5 py-2 rounded-lg shadow mr-2"
          onClick={handleAddEtkinlik}
        >
          Ekle
        </button>
        <button
          className="bg-red-500 text-white px-5 py-2 rounded-lg shadow"
          onClick={() => setAddPopupVisible(false)}
        >
          İptal
        </button>
      </div>
    </div>
  </div>
)}

{confirmDelete && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
      <h2 className="text-xl font-bold mb-4 text-gray-800">Etkinlik Sil</h2>
      <p className="mb-6 text-gray-600">Bu etkinliği silmek istediğinize emin misiniz?</p>
      <div className="flex justify-end">
        <button
          className="bg-red-500 text-white px-5 py-2 rounded-lg shadow mr-2"
          onClick={() => handleDelete(confirmDelete)}
        >
          Sil
        </button>
        <button
          className="bg-gray-300 text-gray-700 px-5 py-2 rounded-lg shadow"
          onClick={() => setConfirmDelete(null)}
        >
          İptal
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
}

export default Etkinlikler;
